/**
 * AssetSelectionRing - the one selection ring drawn on a media asset.
 *
 * Before this primitive, four surfaces each drew their own: a 2px accent border on
 * SelectableImageCard, a white border plus matching inset shadow on the storyboard takes
 * picker, two stacked accent shadows on the node preview thumb, and a border plus double
 * shadow on the agent prompt-cycle thumb. They disagreed on colour, thickness, and whether
 * the ring animated at all.
 *
 * The ring is a masked band that re-processes what is behind it rather than tinting it.
 * A tinted ring averages with the photo underneath, which gives no hard luminance step and
 * makes the ring's brightness swing with the content — bright over shadow, invisible over
 * highlight. That is what reads as muddy, and it is why this is a backdrop-filter band and
 * not a box-shadow.
 *
 * Usage: render inside a positioned, overflow-hidden control that carries
 * `data-selected="true"` when selected. Styling lives in primitives.css and the
 * `--asset-selection-ring-*` tokens; this component takes no props on purpose, so the
 * ring cannot drift per surface again.
 */
const AssetSelectionRing = () => (
  <span className="asset-selection-ring" aria-hidden="true" />
);

export default AssetSelectionRing;
